module.exports = __webpack_public_path__ + "img/sprints.b332d57a.svg";